'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _buffer = require('buffer');

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH_DATA = 'auth_data';

var OAuthPass = function () {
  function OAuthPass() {
    (0, _classCallCheck3.default)(this, OAuthPass);
  }

  (0, _createClass3.default)(OAuthPass, [{
    key: 'init',
    value: function init(clientId, clientSecret, email, password, tokenURI, authorizationURI) {
      var userHasChanged = this.clientId !== clientId || this.clientSecret !== clientSecret || this.email !== email || this.password !== password || this.tokenURI !== tokenURI || this.authorizationURI !== authorizationURI;

      if (userHasChanged) {
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.email = email;
        this.password = password;
        this.tokenURI = tokenURI;
        this.authorizationURI = authorizationURI;
        this.cleanStorage();
      }
    }
  }, {
    key: 'verbose',
    value: function verbose() {
      this.debug = true;
    }
  }, {
    key: 'authenticate',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(email, password) {
        var newToken, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.email = email;
                this.password = password;
                _context.next = 4;
                return this.getToken('password');

              case 4:
                newToken = _context.sent;
                response = newToken && newToken.access_token;
                return _context.abrupt('return', response);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authenticate(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: 'getAccessToken',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var authData, response, accessToken, newToken;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.working) {
                  _context2.next = 6;
                  break;
                }

                if (this.debug) console.log('Waiting to end previous access token request');
                _context2.next = 4;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 50);
                });

              case 4:
                _context2.next = 0;
                break;

              case 6:
                this.working = true;
                _context2.next = 9;
                return this.readStorage();

              case 9:
                authData = _context2.sent;

                if (this.debug) console.log('AuthData from storage', authData);
                response = void 0;

                if (!(authData && authData.access_token)) {
                  _context2.next = 30;
                  break;
                }

                _context2.prev = 13;
                accessToken = (0, _jwtDecode2.default)(authData.access_token);

                if (!(accessToken.user_name === this.email)) {
                  _context2.next = 25;
                  break;
                }

                if (!(Date.now() < Number(authData.expires))) {
                  _context2.next = 21;
                  break;
                }

                if (this.debug) console.log('Valid access token from storage');
                response = authData.access_token;
                _context2.next = 25;
                break;

              case 21:
                if (this.debug) console.log('Refreshing access token');
                _context2.next = 24;
                return this.refreshToken(authData);

              case 24:
                response = _context2.sent.access_token;

              case 25:
                _context2.next = 30;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](13);

                console.log(_context2.t0);

              case 30:
                if (response) {
                  _context2.next = 35;
                  break;
                }

                _context2.next = 33;
                return this.getToken();

              case 33:
                newToken = _context2.sent;

                response = newToken && newToken.access_token;

              case 35:
                this.working = false;
                if (this.debug) console.log('Access Token', response);
                return _context2.abrupt('return', response);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[13, 27]]);
      }));

      function getAccessToken() {
        return _ref2.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: 'getToken',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var grant_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'token';
        var URL, body, response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.debug) console.log('Retrieving new tokens with username and password');
                URL = this.tokenURI;
                _context3.prev = 2;
                body = {
                  username: this.email,
                  password: this.password,
                  grant_type: grant_type
                };
                _context3.next = 6;
                return _axios2.default.post(URL, new URLSearchParams(body).toString(), this.getAuthHeader());

              case 6:
                response = _context3.sent;

                if (!(response.status === 200)) {
                  _context3.next = 10;
                  break;
                }

                this.saveStorage(this.addExpirationDate(response.data));
                return _context3.abrupt('return', response.data);

              case 10:
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](2);

                console.log(_context3.t0);

              case 15:
                return _context3.abrupt('return', null);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 12]]);
      }));

      function getToken() {
        return _ref3.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: 'refreshToken',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(authData) {
        var URL, body, response;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                URL = this.tokenURI;
                _context4.prev = 1;
                body = {
                  refresh_token: authData.refresh_token,
                  grant_type: 'refresh_token'
                };
                _context4.next = 5;
                return _axios2.default.post(URL, new URLSearchParams(body).toString(), this.getAuthHeader());

              case 5:
                response = _context4.sent;

                if (!(response.status === 200)) {
                  _context4.next = 9;
                  break;
                }

                this.saveStorage(this.addExpirationDate(response.data));
                return _context4.abrupt('return', response.data);

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](1);

                console.log(_context4.t0);

              case 14:
                return _context4.abrupt('return', null);

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 11]]);
      }));

      function refreshToken(_x4) {
        return _ref4.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: 'addExpirationDate',
    value: function addExpirationDate(data) {
      var tokenExpiresIn = Math.floor(data.expires_in * 0.8 * 1000);
      return (0, _extends3.default)({}, data, { expires: Date.now() + tokenExpiresIn });
    }
  }, {
    key: 'saveStorage',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(data) {
        var domain;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (typeof Storage !== 'undefined') {
                  localStorage.setItem(AUTH_DATA, JSON.stringify(data));
                } else {
                  domain = window.location.href.endsWith('.abaenglish.com') ? '.abaenglish.com' : '.aba.land';

                  document.cookie = AUTH_DATA + '=' + encodeURIComponent(JSON.stringify(data)) + '; Domain=' + domain + ';';
                }

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveStorage(_x5) {
        return _ref5.apply(this, arguments);
      }

      return saveStorage;
    }()
  }, {
    key: 'readStorage',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var value, _value;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(typeof Storage !== 'undefined')) {
                  _context6.next = 5;
                  break;
                }

                value = localStorage.getItem(AUTH_DATA);
                return _context6.abrupt('return', value ? JSON.parse(value) : null);

              case 5:
                _value = this.getCookieValue(AUTH_DATA);
                return _context6.abrupt('return', _value ? JSON.parse(decodeURIComponent(_value)) : null);

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function readStorage() {
        return _ref6.apply(this, arguments);
      }

      return readStorage;
    }()
  }, {
    key: 'cleanStorage',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (typeof Storage !== 'undefined') {
                  localStorage.removeItem(AUTH_DATA);
                } else {
                  document.cookie = AUTH_DATA + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function cleanStorage() {
        return _ref7.apply(this, arguments);
      }

      return cleanStorage;
    }()
  }, {
    key: 'getCookieValue',
    value: function getCookieValue(key) {
      var cookie = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
      if (cookie) {
        return cookie.pop() || '';
      }
      return '';
    }
  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      return {
        headers: {
          Authorization: this.auth(this.clientId, this.clientSecret),
          Accept: 'application/json, application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    }
  }, {
    key: 'auth',
    value: function auth(username, password) {
      var stringToBytes = typeof _buffer.Buffer === 'function' ? this.btoaBuffer : window.btoa.bind(window);
      return 'Basic ' + stringToBytes(username + ':' + password);
    }
  }, {
    key: 'btoaBuffer',
    value: function btoaBuffer(string) {
      return _buffer.Buffer.from(string).toString('base64');
    }
  }]);
  return OAuthPass;
}();

exports.default = new OAuthPass();